<template>
  <div>
    <img src="../../../public/images/icons/mytrip.svg" alt="My Trip logo" class="mytrip-logo" />
    <p class="no-trips">You don’t have any items<br /> in your trip. Use the heart icon<br /> to add items to this trip.
    </p>
  </div>
</template>

<script>

export default {
  name: 'trip-details-empty-state',
};
</script>

<style scoped>
.mytrip-logo {
  width: 74px;
  height: 74px;
  margin-top: 40px;
}

.no-trips {
  width: 100%;
  height: 83px;
  margin: 0 auto;
  margin-top: 23px;
  font-family: 'IdealSans-Medium';
  font-style: normal;
  font-weight: 350;
  font-size: 24px;
  line-height: 31px;
  color: #1A3138;
}
</style>
